module.exports = __webpack_public_path__ + "static/media/sale-reports-icon.cb759b81.svg";